import { styled, css } from "styled-components";
import media from "../../../../styles/mediaQueries";
import Colors from "../../../../styles/Colors";
import rem from "../../../../utils/rem";
export const StyledAside = styled.aside `
  margin-left: ${(props) => (props.width ? `-${props.width}px` : "-260px")};
  left: ${(props) => (props.width ? `${props.width}px` : "260px")};
  width: ${(props) => (props.width ? `${props.width}px` : "260px")};
  background: ${(props) => props.bgColor || Colors.DARK_WHITE_2024};
  position: fixed;
  height: 100%;
  z-index: 1000;
  transition: all 0.4s cubic-bezier(0.46, 0.03, 0.52, 0.96);
  padding: 20px 0;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  ${media.down("belowMedium") `

  /* Hidden view @mobileVersion */
  ${(props) => props.slidesFromTop &&
    css `
      margin-top: -1210px;
      width: 100%;
      height: unset;
      left: 0;
    `}

    ${(props) => props.slidesFromTop &&
    !props.isOpen &&
    css `
        margin-left: 0;
      `}
  `}

  ${media.only("medium", "belowLarge") `
    margin-left: ${(props) => props.width ? `-${props.width}px` : "-200px"};
    left: ${(props) => props.width ? `${props.width}px` : "200px"};
    width: ${(props) => props.width ? `${props.width}px` : "200px"};
  `}
  @media
    (max-height: 630px)
    and
    (max-width: 1199px)
    and
    (min-width: 992px) {
    padding-bottom: 0;
  }

  @media (max-height: 660px) and (max-width: 1450px) and (min-width: 1200px) {
    padding-bottom: 0;
  }

  ${media.only("large", "xlarge") `
    margin-left: ${(props) => props.width ? `-${props.width}px` : "-200px"};
    left: ${(props) => props.width ? `${props.width}px` : "200px"};
    width: ${(props) => props.width ? `${props.width}px` : "200px"};
  `}

  /* slide from top @mobileVersion */
  ${media.down("belowMedium") `
    left: 0;
    ${(props) => props.slidesFromTop &&
    props.isOpen &&
    css `
        left: ${props.width ? `${props.width}px` : "260px"};
        margin-top: 0px;
        width: 100%;
        transition: all 0.4s ease 0s;
        &:before {
          content: "";
          position: absolute;
          top: 0;
          right: -10px;
          width: 10px;
          height: 100%;
          z-index: 20001;
          background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0.34) 0,
            rgba(255, 255, 255, 0) 100%
          );
        }
      `}


    ${(props) => !props.slidesFromTop &&
    props.isOpen &&
    css `
        left: ${props.width ? `${props.width}px` : "260px"};
        width: ${props.width ? `${props.width}px` : "260px"};
        transition: all 0.4s ease 0s;
        &:before {
          content: "";
          position: absolute;
          top: 0;
          right: -10px;
          width: 10px;
          height: 100%;
          z-index: 20001;
          background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0.34) 0,
            rgba(255, 255, 255, 0) 100%
          );
        }
      `}
    ${(props) => props.isExtended &&
    css `
        width: 60px;
        overflow: hidden;
      `}

    ${(props) => props.isOpen &&
    !props.isExtended &&
    !props.slidesFromTop &&
    css `
        &:after {
          content: "";
          width: 150px;
          right: 0;
          top: 0;
          height: 55px;
          background: ${props.bgColor ? props.bgColor : Colors.DARK_WHITE_2024};
          z-index: 20001;
          position: absolute;
        }
      `}
  `}
`;
export const StyledSidebarToggle = styled.div `
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  padding: 13px 15px 13px;
  z-index: 9999;
  background: ${(props) => props.bgColor || Colors.DARK_WHITE_2024};
  transition: all 0.15s ease;
  display: flex;
  align-items: center;

  ${media.up("medium") `
    display: none;
  `}

  ${media.down("belowMedium") `
    ${(props) => props.slidesFromTop &&
    css `
        padding: 13px 24px 13px;
      `}

    ${(props) => props.isExtended &&
    css `
        background: 0 0;
        z-index: 30000;
      `}
      ${(props) => props.scrollCollapse &&
    !props.isOpen &&
    css `
          top: -75px;
        `}
  `}
`;
export const StyledSidebarWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  position: relative;
  height: 100%;
  min-height: 460px;

  ${media.down("belowMedium") `
    overflow-y: auto;
    padding-bottom: 50px;
  `}

  ${media.up("medium") `
    min-height: 460px;
  `}

  ${media.up("large") `
    min-height: 600px;
  `}
`;
export const PageTitleDesktop = styled.div `
  display: block;
  text-align: center;
  font-size: 20px;
  line-height: 24px;
  margin-top: 25px;
  color: ${Colors.BLACK_2024};
  ${media.only("medium", "belowLarge") `
    font-size: 18px;
    line-height: 22px;
  `}
  ${media.down("belowMedium") `
    display: none;
  `}
`;
export const StyledWrapperLogo = styled.div `
  width: 100%;
  display: none;
  padding-top: 40px;

  a {
    display: block;
    max-height: 40px;
  }
  svg {
    border: 0;
    max-width: 100%;
    width: 180px;
    margin: 0 auto;
    display: block;
  }

  ${media.up("medium") `
    display: block;
  `}

  ${media.only("medium", "belowLarge") `
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 15px;
  `}

  ${media.only("large", "xlarge") `
    padding-left: 30px;
    padding-right: 30px;
  `}
`;
const ButtonNoStyle = styled.button `
  border: none;
  outline: 0;
  background: 0 0;
  appearance: none;
  line-height: initial;
  padding: initial;
  margin: initial;
`;
const srOnly = css `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
export const SidebarToggleBurger = styled(ButtonNoStyle) `
  width: 30px;
  height: 30px;
  position: relative;
  display: inline-block;
  &:before {
    height: 2px;
    position: absolute;
    background: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.WHITE_2024 : Colors.BLACK_2024};
    margin: 5px 0;
    display: block;
    transition: all 0.6s cubic-bezier(0.27, 0.74, 0.32, 1.01);
    content: "";
    width: 100%;
    left: 0;
    transform: rotate(0);
    top: 0;

    ${(props) => props.isOpen &&
    css `
        transform: rotate(45deg);
        top: 10px;
      `}
  }
  &:after {
    height: 2px;
    position: absolute;
    background: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.WHITE_2024 : Colors.BLACK_2024};
    margin: 5px 0;
    display: block;
    transition: all 0.6s cubic-bezier(0.27, 0.74, 0.32, 1.01);
    content: "";
    width: 100%;
    left: 0;
    transform: rotate(0);
    top: 20px;

    ${(props) => props.isOpen &&
    css `
        transform: rotate(-45deg);
        top: 10px;
      `}
  }
  .sr-only {
    ${srOnly}
  }
  .icon-line {
    top: 10px;
    width: 30px;
    opacity: 1;
    height: 2px;
    position: absolute;
    background: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.WHITE_2024 : Colors.BLACK_2024};
    margin: 5px 0;
    display: block;
    transition: all 0.6s cubic-bezier(0.27, 0.74, 0.32, 1.01);
    ${(props) => props.isOpen &&
    css `
        opacity: 0;
      `}
  }

  &:hover {
    cursor: pointer;
  }
`;
export const SidebarToggleSearch = styled(ButtonNoStyle) `
  width: 30px;
  height: 30px;
  position: relative;
  display: block;
  margin-left: ${rem(14)};
  opacity: 1;
  visibility: visible;
  svg {
    width: 100%;
    height: 30px;
    position: relative;
    top: 2px;
    color: ${Colors.BLACK_2024} !important;
    fill: ${Colors.BLACK_2024} !important;
    display: inline-block;
    background-size: 100% !important;
  }

  ${(props) => (props.isOpen || props.isExtended) &&
    css `
      opacity: 0;
      visibility: hidden;
    `}

  &:hover {
    cursor: pointer;
  }
  ${media.up("small") `
    display: none;
  `}
`;
export const MobileLogo = styled.div `
  position: absolute;
  right: 15px;
  transition: all 0.6s cubic-bezier(0.27, 0.74, 0.32, 1.01);
  opacity: 1;
  > a {
    display: block;
    padding: 0;
    margin: 0;
    line-height: 0;
  }

  ${media.down("belowMedium") `
    ${(props) => props.isExtended &&
    css `
        opacity: 0;
        right: 55px;
      `}
  `}
`;
export const LogoLink = styled.a ``;
export const PageTitle = styled.p `
  margin: 0 0 0 ${rem(14)};
  padding: 0;
  font-size: ${rem(18)};
  color: ${Colors.BLACK_2024};

  ${(props) => (props.isOpen || props.isExtended) &&
    css `
      opacity: 0;
      visibility: hidden;
    `}
`;
/** styling for ChevronDown icon */
export const SlideFromTopIconWrapper = styled.div `
  padding: 0;
  > button {
    /* we must override transparent button min height, as nav bar does not support that height.*/
    min-height: 0;
    svg {
      order: 2;
      margin-left: 8px;
    }
  }

  ${({ isOpen }) => isOpen &&
    css `
      > button {
        > svg {
          transform: rotate(180deg);
        }
      }
    `}
`;
export const LogoutWrapper = styled.div `
  padding-bottom: 1rem;
  align-items: flex-end;
  cursor: pointer;
  display: flex;
  align-self: flex-end;
`;
export const LogoutOnlyWrapper = styled.div `
  padding-left: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
`;
export const SelectorWrapper = styled.div `
  display: flex;
  justify-content: flex-start;
`;
export const PaddingRight = styled.span `
  padding-right: ${(props) => props.paddingRight ? `${props.paddingRight}rem` : "0"};
`;
export const Grow = styled.div `
  display: flex;
  flex-grow: 1;
  padding: 0 11px;
  margin-top: 1rem;
`;
export const ClickArea = styled.div `
  cursor: pointer;
  display: flex;
  align-items: center;
`;
export const CurrentLocale = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 0.5rem;
`;
export const SpaceBetween = styled.div `
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=style.js.map